<cs-card>
  <cs-card-title>
    {{ LL.intake.planOverview.nutritionPlan() }}
    @if (editable) {
      <cs-button tertiary [label]="LL.intake.planOverview.edit()" icon="edit"
      (click)="onEditClick()"></cs-button>
    }
  </cs-card-title>
  <cs-card-content>
    <cs-item-list no-padding>
      <p class="nutrition-goal-text">
        {{ LL.intake.planOverview.nutritionGoal() }}
        <span class="goal-highlight">{{ trainingGoalText }}</span>.
        {{ LL.intake.planOverview.nutritionGoalSuffix() }}
      </p>

      <cs-nutrition-stats-row
        [dailyAvg]="nutrition.dailyAvg"
        [mealCalories]="nutrition.isCyclingEnabled ? undefined : nutrition.averageMeal"
        [cutMealCalories]="nutrition.isCyclingEnabled ? nutrition.cutMeal : undefined"
        [bulkMealCalories]="nutrition.isCyclingEnabled ? nutrition.bulkMeal : undefined">
      </cs-nutrition-stats-row>

      <div class="nutrition-stats-row">
        <div class="nutrition-stat-card macros-card">
          <div class="macros-header">
            <cs-label tertiary>{{ getMacroTitle() }}</cs-label>
            @if (nutrition.isCyclingEnabled) {
              <cs-segment [(selection)]="selectedMacroTab">
                <cs-segment-button [value]="MacroTabView.Day">{{ LL.intake.planOverview.macroTabs.day() }}</cs-segment-button>
                <cs-segment-button [value]="MacroTabView.BulkMeal">{{ LL.intake.planOverview.macroTabs.bulkMeal() }}</cs-segment-button>
                <cs-segment-button [value]="MacroTabView.CutMeal">{{ LL.intake.planOverview.macroTabs.cutMeal() }}</cs-segment-button>
              </cs-segment>
            } @else {
              <cs-segment [(selection)]="selectedMacroTab">
                <cs-segment-button [value]="MacroTabView.PerDay">{{ LL.intake.planOverview.macroTabs.perDay() }}</cs-segment-button>
                <cs-segment-button [value]="MacroTabView.PerMeal">{{ LL.intake.planOverview.macroTabs.perMeal() }}</cs-segment-button>
              </cs-segment>
            }
          </div>
          @if (getCurrentMacros(); as macros) {
            <div class="macros-row" [class.flexible]="nutrition.isFlexibleNutrition">
              <div class="macro-item">
                <span class="macro-value protein-color">{{ getMacroValue(macros.protein) }}</span>
                <cs-label secondary>
                  {{ LL.intake.planOverview.protein() }}
                  @if (getMacroSuffix(macros.protein); as suffix) {
                    <span>
                      {{ suffix }}
                    </span>
                  }
                  <help-icon name="info" size="x-small" helpId="@help:references.protein-targets"></help-icon>
                </cs-label>
              </div>
              <div class="macro-item">
                <span class="macro-value carbs-color">{{ getMacroValue(macros.carbs) }}</span>
                <cs-label secondary>
                  {{ LL.intake.planOverview.carbs() }}
                  @if (getMacroSuffix(macros.carbs); as suffix) {
                    <span>
                      {{ suffix }}
                    </span>
                  }
                </cs-label>
              </div>
              <div class="macro-item">
                <span class="macro-value fat-color">{{ getMacroValue(macros.fat) }}</span>
                <cs-label secondary>
                  {{ LL.intake.planOverview.fat() }}
                  @if (getMacroSuffix(macros.fat); as suffix) {
                    <span>
                      {{ suffix }}
                    </span>
                  }
                </cs-label>
              </div>
              <div class="macro-item">
                <span class="macro-value fiber-color">{{ getMacroValue(macros.fiber) }}</span>
                <cs-label secondary>
                  {{ LL.intake.planOverview.fiber() }}
                  @if (getMacroSuffix(macros.fiber); as suffix) {
                    <span>
                      {{ suffix }}
                    </span>
                  }
                </cs-label>
              </div>
            </div>
          }
        </div>
      </div>

      @if (nutrition.isFlexibleNutrition || nutrition.isCyclingEnabled) {
        <cs-text-alert type="info">
          @if (nutrition.isFlexibleNutrition) {
            <help-link helpId="@help:nutrition.flexible">{{ LL.nutrition.flexibleNutritionLink() }}</help-link>
          }
          @if (nutrition.isFlexibleNutrition && nutrition.isCyclingEnabled) {
            {{ LL.common.words.and() }}
          }
          @if (nutrition.isCyclingEnabled) {
            <help-link helpId="@help:intake.advanced-training-techniques-calorie-cycling">{{ LL.nutrition.calorieCyclingLink() }}</help-link>
          }
          {{ nutrition.isFlexibleNutrition && nutrition.isCyclingEnabled ? LL.nutrition.enabledForMealsBoth() : LL.nutrition.enabledForMeals() }}
        </cs-text-alert>
      }
    </cs-item-list>
  </cs-card-content>
</cs-card>